import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../app.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../shared/service/param.context';
import { SingleSiteAnalysisInputModel } from './single-site-analysis-input.model';
import { Observable } from 'rxjs';
import { BreedingViewOutputModel } from './breeding-view-output.model';

@Injectable()
export class SingleSiteAnalysisService {
    private baseUrl = SERVER_API_URL;

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    download(studyId: number, input: SingleSiteAnalysisInputModel) {
        const resourceUrl = `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/single-site-analysis/export`;
        return this.http.post(`${this.baseUrl + resourceUrl}`, input,
            {
                responseType: 'blob',
                observe: 'response'
            }
        );
    }

    exportSSAResults(studyId: number) {
        const resourceUrl = `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/single-site-analysis/results/export`;
        return this.http.get(`${this.baseUrl + resourceUrl}`,
            {
                responseType: 'blob',
                observe: 'response'
            }
        );
    }

    upload(studyId: number, outputModel: BreedingViewOutputModel): Observable<any> {
        const resourceUrl = `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/single-site-analysis/upload`;
        return this.http.post(`${this.baseUrl + resourceUrl}`, outputModel);
    }

    hasExistingMeans(studyId: number, outputModel: BreedingViewOutputModel): Observable<HttpResponse<boolean>> {
        const resourceUrl = `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/single-site-analysis/hasExistingMeans`;
        return this.http.post<boolean>(`${this.baseUrl + resourceUrl}`, outputModel, { observe: 'response' });
    }

    getEnvironmentIdsValidForSSA(studyId: number, plotDatasetId: number): Observable<number[]> {
        const resourceUrl =
            `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/single-site-analysis/validEnvironments/${plotDatasetId}`;
        return this.http.get<number[]>(`${this.baseUrl + resourceUrl}`);
    }
}
